// extracted by mini-css-extract-plugin
module.exports = {"pageHolder":"DeliverRequest_pageHolder__1AHC5","SubmitButtonHolder":"DeliverRequest_SubmitButtonHolder__2QvNI"};